import memoizeOne from "memoize-one";
import isEqual from "lodash/isEqual";
import get from "lodash/get";
import * as groupServices from "../services/group";
import * as partnersServices from "../services/partners";
import local from "../utils/local";

const authority = (item, pers) => {
  if (!item.resource) return item;
  if (item.resource === "dashboard") {
    return item;
  }
  let temp = item.resource;
  if(temp[temp.length - 1] === "s") temp = temp.slice(0,-1);
  if (pers[temp]) {
    return item;
  }
  // return item;
};

// Conversion router to menu.
function formatter(data, rootAuthority, parentName) {
  return data
    .map((item) => {
      if (!item.name || !item.path) {
        return null;
      }

      let locale = "menu";
      if (parentName) {
        locale = `${parentName}.${item.name}`;
      } else {
        locale = `menu.${item.name}`;
      }

      const result = {
        ...item,
        // name: formatMessage({ id: locale, defaultMessage: item.name }),
        name: item.name,
        locale,
        // authority: item.authority || parentAuthority,
      };
      if (item.children) {
        const children = formatter(item.children, rootAuthority, locale);
        // console.log('formatter -> children', children);
        // Reduce memory usage
        result.children = children;
      }
      // delete result.children;
      // return result; //show all no pers
      return authority(result, rootAuthority); // show with pers
    })
    .filter((item) => item);
}

const memoizeOneFormatter = memoizeOne(formatter, isEqual);

/**
 * get SubMenu or Item
 */
const getSubMenu = (item) => {
  // doc: add hideChildrenInMenu
  if (
    item.children &&
    !item.hideChildrenInMenu &&
    item.children.some((child) => child.name)
  ) {
    return {
      ...item,
      children: filterMenuData(item.children), // eslint-disable-line
    };
  }
  if (item.resource) return item; // hiện item ko resource
  return null;
};

/**
 * filter menuData
 */
const filterMenuData = (menuData) => {
  if (!menuData) {
    return [];
  }
  return menuData
    .filter((item) => item.name && !item.hideInMenu)
    .map((item) => getSubMenu(item))
    .filter((item) => item);
};
/**
 * 获取面包屑映射
 * @param {Object} menuData 菜单配置
 */
const getBreadcrumbNameMap = (menuData) => {
  const routerMap = {};

  const flattenMenuData = (data) => {
    data.forEach((menuItem) => {
      if (menuItem.children) {
        flattenMenuData(menuItem.children);
      }
      // Reduce memory usage
      routerMap[menuItem.path] = menuItem;
    });
  };
  flattenMenuData(menuData);
  return routerMap;
};

const memoizeOneGetBreadcrumbNameMap = memoizeOne(
  getBreadcrumbNameMap,
  isEqual
);

export default {
  namespace: "menu",

  state: {
    menuData: [],
    breadcrumbNameMap: {},
    roles: {}
  },

  effects: {
    *setRoles({ payload },{ put }){
      yield put({
        type: "saveRole",
        payload,
      });
    },
    *getMenuData({ payload }, { put, call, all, select }) {
      const uId = (local.get("auth") || {}).id;
      const persGroup = yield call(groupServices.getUserInGroup, uId);
      const partnerId = get(persGroup, ["partner_id"], "");
      let partner;
      if (typeof partnerId === "string" && partnerId !== "") {
        partner = yield call(partnersServices.get, partnerId);
      }
      // let pers = get(
      //   get(persGroup, ["group"], {}),
      //   ["menus"],
      //   []
      // );
      // pers = pers.reduce((acc, cur) => {
      //   try {
      //     const curObj = JSON.parse(cur);
      //     return ({
      //       ...acc,
      //       [Object.keys(curObj)]: Object.values(curObj)[0]
      //     });
      //   } catch (error) {
      //     return {
      //       ...acc,
      //       cur
      //     };
      //   }
      // }, {});
      let pers = yield select(state => state.menu.roles);
      // if (roles && roles.length > 0 && !roles[0].collector_group_id) {
      //   return true;
      // }
      if (!pers) pers = {};
      /* if (pers && pers.group && pers.group.menus) {
        let persMenus = []
        for (let menu of pers.group.menus) {
          try {
            const newMenu = JSON.parse(menu);
            if (newMenu) {
              persMenus.push(Object.values(newMenu)[0]);
            }
          } catch (error) {

          }
        }
      } */
      const { routes, authority } = payload;
      const menuFormatered = memoizeOneFormatter(routes, pers);
      const menuData = filterMenuData(menuFormatered);
      const breadcrumbNameMap = memoizeOneGetBreadcrumbNameMap(menuData);
      yield all([
        yield put({
          type: "save",
          payload: { menuData, breadcrumbNameMap },
        }),
        yield put({
          type: "auth/setPartner",
          payload: partner ? { ...partner } : undefined,
        }),
      ]);
    },
  },

  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    saveRole(state, action){
      return {
        ...state,
        roles: action.payload
      }
    }
  },
};
